import React, { useState } from "react";
import { Dialog, useMediaQuery } from "@mui/material";
import AccessLogin from "./lightLogin/accessLogin";
import AccessSignup from "./createLight/AccessSignup";
import { useTheme } from "@mui/material/styles";

export const AuthDialogContext = React.createContext();

function AuthDialog({ children }) {
  const [openLogin, setOpenLogin] = useState(false);
  const [openSignup, setOpenSignup] = useState(false);
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("lg"));
  const openLoginDialog = () => {
    setOpenSignup(false);
    setOpenLogin(true);
  };

  const openSignupDialog = () => {
    setOpenLogin(false);
    setOpenSignup(true);
  };

  const closeDialog = () => {
    setOpenLogin(false);
    setOpenSignup(false);
  };

  return (
    <AuthDialogContext.Provider
      value={{
        openLoginDialog,
        openSignupDialog,
        closeDialog,
      }}
    >
      {children}

      <Dialog
        maxWidth={isLargeScreen ? "lg" : "md"}
        fullWidth
        open={openLogin}
        onClose={closeDialog}
        sx={{
          backdropFilter: 'blur(8px) brightness(0.92)',
          background: 'radial-gradient(ellipse at 60% 10%, #182c2b 0%, #10181f 100%)',
          '& .MuiPaper-root': {
            background: 'none',
            boxShadow: 'none',
            borderRadius: 6,
            overflow: 'visible',
            p: 0,
          },
        }}
        PaperProps={{
          sx: {
            background: 'none',
            boxShadow: 'none',
            borderRadius: 6,
            overflow: 'visible',
            p: 0,
          }
        }}
      >
        <AccessLogin closeDialog={closeDialog} />
      </Dialog>

      <Dialog
        maxWidth={isLargeScreen ? "lg" : "md"}
        fullWidth
        open={openSignup}
        onClose={closeDialog}
        sx={{
          backdropFilter: 'blur(8px) brightness(0.92)',
          background: 'radial-gradient(ellipse at 60% 10%, #182c2b 0%, #10181f 100%)',
          '& .MuiPaper-root': {
            background: 'none',
            boxShadow: 'none',
            borderRadius: 6,
            overflow: 'visible',
            p: 0,
          },
        }}
        PaperProps={{
          sx: {
            background: 'none',
            boxShadow: 'none',
            borderRadius: 6,
            overflow: 'visible',
            p: 0,
          }
        }}
      >
        <AccessSignup closeDialog={closeDialog} />
      </Dialog>
    </AuthDialogContext.Provider>
  );
}

export default AuthDialog;
